import { Icon } from '../design/Icon';
import type { sessionStats } from './useSessionStats';

const inactivityRule =
  'Recent practice groups saved attempts until a gap of 30 minutes or more without activity, measured from the previous attempt’s end to the next attempt’s start.';

export function RecentPractice({
  stats,
  resume,
  viewHistory,
}: {
  stats: ReturnType<typeof sessionStats>;
  resume?: () => void;
  viewHistory: () => void;
}) {
  return (
    <section className="recent-practice" aria-label="Recent practice">
      <div className="recent-practice-heading">
        <h2>Recent practice</h2>
        <button
          onClick={resume ?? viewHistory}
          aria-label={resume ? 'Resume current puzzle' : 'View recent practice'}
        >
          {resume ? 'Resume' : 'View history'} <Icon name="arrow" />
        </button>
      </div>
      <dl className="session-strip" aria-label="Recent practice statistics" title={inactivityRule}>
        <div title={`Solved tactics, excluding revealed solutions. ${inactivityRule}`}>
          <dt>Solved</dt>
          <dd data-testid="recent-solved">{stats.solved}</dd>
        </div>
        <div title={`Consecutive first-try solves without mistakes or hints. ${inactivityRule}`}>
          <dt>Streak</dt>
          <dd data-testid="recent-streak">{stats.streak}</dd>
        </div>
        <div
          title={`First-try solves as a percentage of solved or revealed tactics. ${inactivityRule}`}
        >
          <dt>First try</dt>
          <dd data-testid="recent-first-try">
            {stats.firstTry === null ? '—' : `${stats.firstTry}%`}
          </dd>
        </div>
      </dl>
    </section>
  );
}
